// React&NextJS
import React, { Component } from 'react'
// 3rd party libraries
import { connectInfiniteHits } from 'react-instantsearch-dom'
import PropTypes from 'prop-types'
// Services&Helper functions
import helperFunctions from '../../../utils/helperFunctions'
// Types
import { MemoryRefType } from '../../../types/types'
// Styles
import s from './Search.module.scss'
import c from 'classnames'
// Components
import Card from '../../cards/card/Card'

type HitType = MemoryRefType & {
    objectID: string
}
type HitsType = Array<HitType>

function Hit({ hit, className }) {
    const pos = hit.__position
    const m = hit.data
    const birthDate = helperFunctions.getDate(m.birth)
    const deathDate = helperFunctions.getDate(m.death)

    const biography = m.biography && JSON.parse(m.biography)
    return (
        <Card
            className={className}
            description={biography}
            header={m.fullName}
            headerSize="h3"
            imageSrc={m.profileImg}
            lifeTime={`${birthDate} - ${deathDate}`}
            size="1"
            to={[
                { link: `/memories/${hit.objectID}`, label: 'Lesa meira' },
                {
                    link: `/memories/${hit.objectID}/obituaries/form`,
                    label: 'Skrifa minningargrein',
                },
                // {
                //     link: `/memories/${hit.objectID}#condolences`,
                //     label: 'Senda kveðju',
                // },
            ]}
            imagePosition={pos % 2 == 0 ? 'r' : 'l'}
        />
    )
}

class InfiniteHits extends Component<{
    hits: HitsType
    isLoading: boolean
    hasMore: boolean
    refineNext: Function
}> {
    static propTypes = {
        hits: PropTypes.arrayOf(PropTypes.object).isRequired,
        hasMore: PropTypes.bool.isRequired,
        refineNext: PropTypes.func.isRequired,
    }
    observer: IntersectionObserver = null
    sentinel: HTMLLIElement = null

    onSentinelIntersection = (entries) => {
        const { hasMore, refineNext } = this.props
        entries.forEach((entry) => {
            if (entry.isIntersecting && hasMore) {
                refineNext()
            }
        })
    }

    componentDidMount() {
        this.observer = new IntersectionObserver(this.onSentinelIntersection)

        this.observer.observe(this.sentinel)
    }

    componentWillUnmount() {
        this.observer.disconnect()
    }

    render() {
        const { hits, isLoading } = this.props

        return (
            <div className={c('ais-InfiniteHits', s.hits)}>
                <ul className={c('ais-InfiniteHits-list')}>
                    {hits.map((hit) => (
                        <Hit
                            hit={hit}
                            key={hit.objectID}
                            className="ais-InfiniteHits-item"
                        />
                    ))}
                    <li
                        className="ais-InfiniteHits-sentinel"
                        // @ts-ignore
                        ref={(c) => (this.sentinel = c)}
                    />
                    {!hits.length && !isLoading && (
                        <Card
                            className={'ais-InfiniteHits-item'}
                            description={'Prófaðu að leita aftur.'}
                            header={'Engin minningarsíða fannst'}
                            headerSize="h3"
                            imageSrc="https://firebasestorage.googleapis.com/v0/b/minning-f44b2.appspot.com/o/static%2Frachel-coyne-5WHCV4DkHXA-unsplash.jpeg?alt=media&token=0888573b-9efa-4678-9429-e7639b9e9260"
                            // lifeTime={`${birthDate} - ${deathDate}`}
                            to={[
                                {
                                    link: `/memories/form`,
                                    label: 'Stofna minningarsíðu',
                                },
                            ]}
                            size="1"
                            imagePosition={'l'}
                        />
                    )}
                </ul>
            </div>
        )
    }
}

export default connectInfiniteHits(InfiniteHits)
